import { httpsCallable } from 'firebase/functions';
import { functions } from './firebase';

export type ExtractEntityDocumentTextResponse = {
  text: string;
};

export function extractEntityDocumentTextErrorMessage(err: unknown): string {
  if (err && typeof err === 'object' && 'code' in err) {
    const code = String((err as { code: string }).code);
    if (code === 'functions/failed-precondition') {
      return 'File exceeds the 15 MB size limit.';
    }
    if (code === 'functions/not-found') {
      return 'Document not found in storage.';
    }
    if (code === 'functions/permission-denied') {
      return 'You do not have permission to read this document.';
    }
    if (code === 'functions/unauthenticated') {
      return 'Sign in to extract document text.';
    }
  }
  return err instanceof Error ? err.message : 'Text extraction failed.';
}

export async function extractEntityDocumentText(storagePath: string): Promise<string> {
  const fn = httpsCallable<{ storagePath: string }, ExtractEntityDocumentTextResponse>(
    functions,
    'extractEntityDocumentText'
  );
  const result = await fn({ storagePath: storagePath.trim() });
  return typeof result.data.text === 'string' ? result.data.text : '';
}
